import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { AnalyticsService } from '../services/analytics.service';

/**
 * Updates the dataLayer content_clicked
 * Data attributes may need to be added to the html element
 * [attr.content_link] only for (click) components
 * [attr.content_type] if not web - faults - cta
 * e.g.
 * <button
 * [attr.content_link]="/blah/blah"
 * [attr.content_type]="'components'"></button>
 */
@Directive({
  selector: '[vmGtmCta]',
  standalone: true,
})
export class AnalyticsCTADirective {
  element = inject(ElementRef);
  analyticsService = inject(AnalyticsService);

  @HostListener('click', ['$event'])
  onClick(e: MouseEvent) {
    const element = this.element.nativeElement;
    let extras = {};

    if (element.localName === 'vo-tabs') {
      extras = this.tabCTA(element);
    } else {
      extras = this.commonCTA(element);
    }

    this.analyticsService.addContentClickedToDataLayer(extras);
    e.stopPropagation();
  }

  commonCTA(element) {
    const href = element.href;
    const contentLink = element.attributes.getNamedItem('content_link');
    const contentType = element.attributes.getNamedItem('content_type');
    const contentName = element.attributes.getNamedItem('content_name') || { value: element.innerText };
    const extras = {
      content_type: `web - faults - ${contentType ? contentType.value : 'cta'}`,
      content_name: contentName.value,
      content_link: '',
    };

    if (contentLink) {
      extras.content_link = contentLink.value;
    } else if (href) {
      extras.content_link = href;
    }

    return extras;
  }

  tabCTA(element) {
    const tab = element.querySelector('button.tab-list__tab--is-active');

    const extras = {
      content_type: `web - faults - tab`,
      content_name: tab.innerText,
      content_link: '',
    };

    return extras;
  }
}
